import { useState, useEffect, ChangeEvent } from 'react';
import { FormInput, FormInputMultiline, DatePickerComponent, FormControlRadio, FormRadio, FormSelect } from '../../../component/input/InputStyle';
import GridComponent from '../../../component/grid/GridComponent.component';
import { useFormik } from 'formik';
import FormLabel from '../../../component/input/FormLabel.component';
import Grid from '@material-ui/core/Grid';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import { Form } from '../../../component/form/Form';
import CorporateCommunicated from '../interfaces/CorporateCommunicated';
import { FormInterface } from '../../../core/interfaces/form/Form';
import useModal from '../../../hooks/useModal';
import ModalImg from '../../../component/modal/modalImg/ModalImg.component';
import Group from '../groups/interfaces/Group';
import { getGroups } from '../groups/Groups.service';
import { useSnackbar } from '../../../context/Snackbar';
import Autocomplete from '@material-ui/core/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getGroup } from '../groups/assignEmployee/Employee.service';
import { AxiosResponse } from 'axios';
import Progress from '../../../component/progress/Progress.component';
import ButtonImport from '../../../component/buttton/ButtonImport.component';
import { FormatHours } from '../../../utils/format/FormatDate';
import MenuItem from '@material-ui/core/MenuItem';
import { MoreInformation, MoreInformationInterface } from '../utils/MoreInformation';

export default function FormComponent({ handleSubmitForm, initialValues, disabled, children }: FormInterface<CorporateCommunicated>) {

  const [open, addModal] = useModal();
  const [groups, setGroups] = useState<Group[]>([]);
  const { setSnackbar } = useSnackbar();
  const [loading, setLoading] = useState<boolean>(true);
  const [groupsDefault, setGroupsDefault] = useState<Group[]>([]);
  const [fileName, setFileName] = useState<string>('');

  useEffect(() => {
    responseGroup();
  }, [setSnackbar]);

  const { handleSubmit, handleChange, values, setFieldValue } = useFormik<CorporateCommunicated>({
    initialValues: initialValues,
    onSubmit: values => {
      if (!Number(values.Privacidade)) {
        values.GrupoId = [];
      }
      values.TextButton = values.TextButton.toString();
      values.Privacidade = Number(values.Privacidade);
      handleSubmitForm({ ...values });
    },
  });

  const responseGroup = async () => {
    const response: AxiosResponse<Group[]> = await getGroups();
    setGroups(response.data);
    if (initialValues.Id) {
      await getGroup(initialValues.Id).then(res => {
        const groupFilter: Group[] = filter(response.data, res.data);
        setGroupsDefault(groupFilter);
        setFieldValue('GrupoId', groupFilter);
      }).catch((error) => {
        console.log('Erro ao consultar comunicado!', error);
      }).finally(() => {
        setLoading(false);
      });
    }
    setLoading(false);
  }

  const handleChangeImg = (event: ChangeEvent<HTMLInputElement>): void => {

    if (event.target.files?.length) {
      let file = event.target.files[0];
      setFileName(file.name)
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setFieldValue('ImagemCode', reader.result);
      };
    }
  }

  const filter = (groups: Group[], groupsDefault: Group[]): Group[] => {
    return groups.filter((group: Group) => groupsDefault.some((groupDefault: Group) => group.Id === groupDefault.GrupoId))
  }

  const handleChangeRadio = (event: ChangeEvent<HTMLInputElement>) => {
    let { value, name } = event.target;
    setFieldValue(name, value);
    value === 't' ? setFieldValue('ImagemCode', '') : setFieldValue('TextoDetalhe', '');
  }

  if (initialValues.Id && loading) {
    return <Progress open={loading} />
  }

  return (
    <Form onSubmit={handleSubmit}>
      <GridComponent justify="flex-start" alignItems="flex-start" spacing={2} >
        <Grid item xs={12} sm={12} md={7} >
          <GridComponent justify="flex-start" alignItems="center" spacing={2} >
            <FormLabel title="Assunto" sm={12} md={10} required={!disabled}>
              <FormInput
                name="Assunto"
                value={values.Assunto}
                onChange={handleChange}
                disabled={disabled}
                required
              />
            </FormLabel>
            <FormLabel title="Conteúdo" sm={12} md={10} required={(values.Tipo === 't') && !disabled}>
              <FormInputMultiline
                minRows={4}
                name="TextoDetalhe"
                value={values.TextoDetalhe || ''}
                onChange={handleChange}
                disabled={!(values.Tipo === 't') || disabled}
                required={values.Tipo === 't'}
              />
            </FormLabel>
            <Grid item xs={12} >
              <GridComponent justify="flex-start" alignItems="flex-end" >
                <FormLabel title="imagem" sm={12} md={10} required={(values.Tipo === 'i') && !disabled}>
                  <ButtonImport
                    onChange={(event: ChangeEvent<HTMLInputElement>) => handleChangeImg(event)}
                    disabled={!(values.Tipo === 'i') || disabled}
                    fileName={values.ImagemCode && !fileName && values.Tipo !== 't' ? 'image' : fileName}
                  />
                </FormLabel>
                {values.ImagemCode && (
                  <ModalImg open={!!open} onClick={() => addModal(!open)} img={values.ImagemCode} icon={true} />
                )}
              </GridComponent>
            </Grid>

            <FormLabel title="Link Ação" sm={12} md={10} lg={6}>
              <FormInput
                name="LinkDetalhe"
                value={values.LinkDetalhe || ''}
                onChange={handleChange}
                disabled={disabled}
              />
            </FormLabel>
            <FormLabel title="Texto da ação" sm={12} md={10} lg={4} required={!disabled}>
              <FormSelect
                displayEmpty={true}
                name='TextButton'
                value={Number(values.TextButton ?? MoreInformation[0].key)}
                onChange={handleChange}
              >
                {MoreInformation.map((information: MoreInformationInterface, index: number) => {
                  return <MenuItem value={String(information.key || index)} key={index}>{information.value}
                  </MenuItem>
                })}
              </FormSelect>
            </FormLabel>
          </GridComponent>
        </Grid>

        <Grid item xs={12} sm={12} md={5}>
          <GridComponent justify="flex-start" alignItems="center" spacing={2} >
            <FormLabel title="Tipo do comunicado" required={!disabled} sm={12} md={10}>
              <FormRadio value={values.Tipo || ''} name="Tipo" onChange={handleChangeRadio} row>
                <FormControlRadio
                  label="TEXTO"
                  value='t'
                  disabled={disabled}
                  required
                />
                <FormControlRadio
                  label="IMAGEM"
                  value="i"
                  disabled={disabled}
                  required
                />
              </FormRadio>
            </FormLabel>
            <FormLabel title="data de início" sm={12} md={12} lg={6} required={!disabled}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePickerComponent
                  value={values.DataInicio || null}
                  maxDateMessage="data não pode ser maior que Data de Fim"
                  maxDate={values.DataFim || null}
                  onChange={(date: Date | string) => setFieldValue('DataInicio', FormatHours(date, '00:00:00'))}
                  disabled={disabled}
                  renderInput={(props: any) => <FormInput {...props} />}
                  required
                />
              </LocalizationProvider>
            </FormLabel>
            <FormLabel title="data de fim" sm={12} md={12} lg={6} required={!disabled}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePickerComponent
                  value={values.DataFim || null}
                  minDate={values.DataInicio || null}
                  maxDateMessage="data não pode ser menor que Data de Inicio"
                  onChange={(date: Date | string) => setFieldValue('DataFim', FormatHours(date, '23:59:59'))}
                  disabled={disabled}
                  renderInput={(props: any) => <FormInput {...props} />}
                  required
                />
              </LocalizationProvider>
            </FormLabel>
            <FormLabel title="Destinatários" required={!disabled} sm={12} md={10}>
              <FormRadio value={String(values.Privacidade) || ''} name="Privacidade" onChange={handleChange} row>
                <FormControlRadio
                  label="Público geral"
                  value='0'
                  disabled={disabled}
                  required
                />
                <FormControlRadio
                  label="Grupos específicos"
                  value="1"
                  disabled={disabled}
                  required
                />
              </FormRadio>
            </FormLabel>

            <FormLabel title="Selecione o Grupo" sm={12} md={12} required={!disabled && !!Number(values.Privacidade)} >
              <Autocomplete
                multiple
                id='combo-box-gupos'
                size='small'
                options={groups}
                getOptionLabel={(option: Group) => option.Nome}
                isOptionEqualToValue={(option: Group, value: Group) => option.Id === value.Id}
                filterSelectedOptions
                loading={loading}
                onChange={(_event: React.ChangeEvent<any>, group: Group[]) => {
                  setFieldValue('GrupoId', group);
                }}
                disabled={disabled || !Number(values.Privacidade)}
                defaultValue={groupsDefault}
                renderInput={(params) => (
                  <FormInput {...params}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        < >
                          {loading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </ >
                      ),
                    }}
                  />
                )}
              />

            </FormLabel>
          </GridComponent>
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </GridComponent>
    </Form>
  )
}
